export const DOCUMENT_TYPES: any[] = [
    {id: 1, name: 'Списък персонал', description: 'Списък персонал' },
    {id: 2, name: 'Списък персонал с Телк', description: 'Списък персонал с Телк' },
    {id: 3, name: 'Телк решение', description: 'Телк решение' },
    {id: 4, name: 'Заповед комисия за трудоустрояване', description: 'Заповед комисия за трудоустрояване' },
    {id: 5, name: 'Трудоустрояване', description: 'Трудоустрояване' },
    {id: 6, name: 'Трайни увреждания', description: 'Трайни увреждания' },
    {id: 7, name: 'Производствена характеристика', description: 'Производствена характеристика' },
    {id: 8, name: 'Становище от доктор', description: 'Становище от доктор' },
    {id: 9, name: 'Медицинско свидетелство', description: 'Медицинско свидетелство' },
    {id: 10, name: 'Болничен лист', description: 'Болничен лист' },
    {id: 11, name: 'Документ с анализ', description: 'Документ с анализ' },
    {id: 12, name: 'Прегледи', description: 'Прегледи' },
    {id: 13, name: 'Декларация по чл.15', description: 'Декларация по чл.15' },
    {id: 14, name: 'Друг', description: 'Друг' },
]
export const DOCUMENT_TYPE_PLACEHOLDER = {
    id: null, 
    name: 'Моля изберете тип документ'
}